import { LUXURY_PLUS_PATHS } from 'loyalty/constants/base'

export function getCheckoutRouteFromURL(pathname: string): string {
  const split = pathname.split('/').pop() || ''
  return split?.split('?')[0]
}

export function getOnPurchaseSuccessPath(order: App.Order, isLuxuryPlusEnabled: boolean): string {
  const { itemsCount, id: orderId, subscriptionItems } = order

  const DEFAULT_REDIRECT_PATH = `/booking/confirmation?orderId=${orderId}`
  const hasSubscriptionItems = subscriptionItems.length > 0

  if (hasSubscriptionItems && isLuxuryPlusEnabled && itemsCount === 1) return `/${LUXURY_PLUS_PATHS.ACCOUNT_MANAGEMENT_PAGE}?subscription=new`
  return DEFAULT_REDIRECT_PATH
}
